module.exports = __webpack_public_path__ + "static/media/img_privado.08753bad.jpg";